import api from '@api/Api';

export default {

    getSegment(id) {
        return api().get(`/segments/${id}`);
    },

    updateSegment(id, params) {
        return api().put(`/segments/${id}`, params);
    },

    updateSegmentName(id, name) {
        return api().put(`/segments/${id}/name`, { name: name });
    },

    duplicateSegment(id) {
        return api().post(`/segments/${id}/duplicate`);
    },

    deleteSegment(id) {
        return api().delete(`/segments/${id}`);
    },

    exportSegment(id, params) {
        return api().post(`/segments/${id}/exports`, params);
    },

    syncSegment(id) {
        return api().post(`/segments/${id}/sync`);
    },

}
